import { Button, Chip, Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import { TabControl, TabContent } from "src/framework/components/navigations";
import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { FinanciamentosProvider } from "src/providers/pagamentos/FinancimentosProvider";
import { DocumentosPagamentosType, FinanciamentosPlanosTypes, FinanciamentosUploadsType, PedidoType, PessoasUploadsDocumento, SITUACAO_FINANCIAMENTOS_UPLOADS, SITUACAO_PROPOSTA_PLANO, TIPO_PESSOA_DOCUMENTO, TOrigemDocumentoPessoa } from "src/types";
import { PlanosDataTable } from "../../financiamento/PlanosDataTable";
import CloseIcon from '@material-ui/icons/Close';
import { FullWidthButton } from "src/framework/components/buttons";
import { confirmationDialog, notifierStore } from "src/framework/store";
import "./styles.scss";
import { Documentos } from "./Documentos";
import { Formater, TypeRecords } from "src/framework/commons";
import { QRCodeSVG } from "qrcode.react";
import { IAssinatura, IFormalizacao } from "./type";
import { Alert } from "@material-ui/lab";
import moment from "moment";
import { PedidosProvider } from "src/providers/pagamentos/PedidoProvider";
import { PedidoStore } from "src/store/vendas/PedidoStore";

export interface FinanciamentoDocumentosProperties {
    open: boolean;
    onClose: () => void;
    pedido: PedidoType | null;
    onConfirm: (close: boolean) => void;
}

const financiamentoProvider = new FinanciamentosProvider();
const pedidosProvider = new PedidosProvider();

const ETAPA_FINANCIAMENTO_PLANOS = "planos"
const ETAPA_FINANCIAMENTO_ASSINATURA = "assinatura"
const ETAPA_FINANCIAMENTO_DOCUMENTOS = "documentos"


const ETAPAS = {
    [`${ETAPA_FINANCIAMENTO_PLANOS}`]: "Planos",
    [`${ETAPA_FINANCIAMENTO_ASSINATURA}`]: "Assinatura",
    [`${ETAPA_FINANCIAMENTO_DOCUMENTOS}`]: "Documentos"
}

const FinanciamentoDocumentos: FC<FinanciamentoDocumentosProperties> = ({ open, onClose, pedido, onConfirm }) => {
    const [formalizacao, setFormalizacao] = useState<IFormalizacao | null>(null);
    const [tabManutencao, setTabManutencao] = useState("dados_pessoais");
    const [etapas, setEtapas] = useState<string[]>([]);
    const [etapasConcluidas, setEtapasConcluidas] = useState<string[]>([]);
    const [etapaAtual, setEtapaAtual] = useState<string>(ETAPA_FINANCIAMENTO_PLANOS);
    const [planosState, setPlanosState] = useState<FinanciamentosPlanosTypes[]>()
    const [documentosState, setDocumentosState] = useState<DocumentosPagamentosType[]>();
    const [planoState, setPlanoState] = useState<FinanciamentosPlanosTypes | null>(null);
    const [assinatura, setAssinatura] = useState<IAssinatura | null>(null);
    const [pessoasState, setPessoasState] = useState<PessoasUploadsDocumento[]>();

    const handleChangeTabManutencao = (tab: string) => {
        setTabManutencao(tab);
    }

    const saveArquivos = async (documentos: DocumentosPagamentosType[]): Promise<DocumentosPagamentosType[] | null> => {
        const url: string = `/pagamentos/financiamentos/uploads/` + pedido?.codigo_venda;
        const documentosRetorno: DocumentosPagamentosType[] = [];

        let tudoCerto = true;

        if (documentos) {
            for (const doc of documentos) {
                const arquivoSplit = doc.arquivoSelecionado ? doc.arquivoSelecionado.split(".") : "";
                const arquivo = doc.origem?.toLocaleLowerCase() + "_" + doc.id?.toString() + "." + arquivoSplit[arquivoSplit.length - 1];
                const request: IDataRequest = {
                    url: url,
                    data: doc.formData,
                }

                const response = await api.post(request);
                if (response.statusCode !== STATUS_CODE.OK) {
                    tudoCerto = false;

                    break;
                }

                documentosRetorno.push({
                    ...doc,
                    url: response.data[arquivo].path,
                });
            };

            return documentosRetorno && tudoCerto ? documentosRetorno : null;
        }

        return null;
    }

    const saveEnviarDocumentos = async () => {
        if (pedido?.pagamentos?.financiamentos) {
            const financiamento = pedido?.pagamentos?.financiamentos[0] || null;
            const message = [];

            const result = await financiamentoProvider.putEnviarDocumentos(financiamento.id, planoState?.id ? planoState?.id : 0, pedido.codigo_venda);

            if (result.statusCode === STATUS_CODE.OK) {
                message.push("Documentos enviados para análise!");
            } else {
                message.push(...result.message);
            }

            notifierStore.setNotifier({
                title: "Aviso",
                content: message,
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false)
                }
            })
            notifierStore.setOpen(true)
        }
    }

    const enviarPlano = async (): Promise<void> => {
        const financiamento = pedido?.pagamentos?.financiamentos ?  pedido?.pagamentos?.financiamentos[0] : null;

        if (!financiamento) {
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: "Não foi possível processar o envio do plano",
                onClose: () => {
                    notifierStore.setOpen(true);
                },
                timeOut: 2500
            })
            notifierStore.setOpen(true);
            return;
        }

        if (planoState && financiamento) {
            const result = await financiamentoProvider.enviaPlano(Number(planoState?.id), financiamento.id);
            
            if (result.statusCode !== STATUS_CODE.OK) {
                notifierStore.setNotifier({
                    title: "Aviso!!!",
                    content: "Não foi possível processar o envio do plano",
                    onClose: () => {
                        notifierStore.setOpen(false);
                    },
                    timeOut: 2500
                })
                notifierStore.setOpen(true);
            }

            setEtapaAtual(etapas.includes("assinatura") ? "assinatura" : "documentos");
            await getFormalizacao();
            return;
        }

    }

    const validarPlanoSelecionado = (): boolean => {
        if (!planoState) {
            notifierStore.setNotifier({
                title: "Aviso",
                content: "Plano não foi confirmado, realize a confirmação antes de seguir.",
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false);
                    handleChangeTabManutencao("planos");
                }
            })
            notifierStore.setOpen(true);

            return false;

        }

        return true;
    }

    const validarDocumentos = (): boolean => {
        const documentosPendentes: { origem?: TOrigemDocumentoPessoa, mensagens: string[] }[] = [];

        documentosState?.forEach((doc: DocumentosPagamentosType) => {
            if (doc.situacao === SITUACAO_FINANCIAMENTOS_UPLOADS.PENDENTE || doc.situacao === SITUACAO_FINANCIAMENTOS_UPLOADS.REVISAO) {
                let documentoPendente = documentosPendentes.find(rec => rec.origem === doc.origem);

                if (!documentoPendente) {
                    documentoPendente = {
                        origem: doc.origem,
                        mensagens: [],
                    }

                    documentosPendentes.push(documentoPendente);
                }

                documentoPendente.mensagens.push(`Documento ${doc.titulo} ainda não foi realizado o upload.`);
            }
        });

        if (documentosPendentes.length) {
            notifierStore.setNotifier({
                title: "Aviso",
                content: <>{
                    documentosPendentes.map(rec => {
                        return (
                            <>
                                <strong>{descricaoOrigem(rec.origem)}</strong><br />
                                {
                                    rec.mensagens.map(msg => {
                                        return (
                                            <>-{msg}<br /></>
                                        )
                                    })
                                }
                            </>
                        )
                    })
                }</>,
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false)
                }
            })
            notifierStore.setOpen(true);
            return false;
        }

        return true;
    }

    const descricaoOrigem = (origem?: TOrigemDocumentoPessoa) => {
        switch (origem) {
            case "conjuge": return "Cônjuge";
            case "avalista": return "Avalista";
            case "avalista_conjuge": return "Avalista Cônjuge";
            default: return "Titular";
        }
    }

    const getFormalizacao = async (): Promise<void>  => {
        if (pedido?.pagamentos?.financiamentos) {
            const response: IDataResponse = await financiamentoProvider.getFormalizacaoDocumentos(pedido?.pagamentos?.financiamentos[0].id)
            if (response.statusCode === STATUS_CODE.OK) {
                setFormalizacao(response.data)
                setDocumentosState(response.data.documentos);
                setPessoasState(response.data.pessoas);
                setPlanosState(response.data.planos);
                setEtapas(response.data.etapas);
                setEtapaAtual(response.data.etapa);
                setPlanoState(response.data.planos.find((p: FinanciamentosPlanosTypes) => p.selecionado === true));
                if (response.data.etapa === ETAPA_FINANCIAMENTO_PLANOS) {
                    setEtapasConcluidas([ETAPA_FINANCIAMENTO_PLANOS])
                }
                if (response.data.etapa === ETAPA_FINANCIAMENTO_ASSINATURA) {
                    const _assinatura: IAssinatura = response.data.assinatura
                    setEtapasConcluidas([ETAPA_FINANCIAMENTO_PLANOS, ETAPA_FINANCIAMENTO_ASSINATURA]);
                    setAssinatura(_assinatura);
                }
                if (response.data.etapa === ETAPA_FINANCIAMENTO_DOCUMENTOS) {
                    setEtapasConcluidas([ETAPA_FINANCIAMENTO_PLANOS, ETAPA_FINANCIAMENTO_ASSINATURA, ETAPA_FINANCIAMENTO_DOCUMENTOS])
                }

                if(response.data.documentos && response.data.documentos?.filter((doc: any) => doc.origem === TIPO_PESSOA_DOCUMENTO.PROPONENTE).length < 1){
                    setTabManutencao("dados_pessoais_avalista_0" )
                }
            }
        }
    }

    const regerarAssinatura = async () : Promise<void> => {
        if (pedido?.pagamentos?.financiamentos) {
            const response: IDataResponse = await financiamentoProvider.gerarNovoLinkAssinatura(pedido?.pagamentos?.financiamentos[0].id)
            if (response.statusCode === STATUS_CODE.OK) {
                if (response.data.etapa === ETAPA_FINANCIAMENTO_ASSINATURA) {
                    const _assinatura: IAssinatura = response.data
                    setAssinatura(_assinatura);
                }
            }
        }
    }

    useEffect(() => {
        if (formalizacao) {
            setAssinatura(formalizacao.assinatura)
        }
    }, [formalizacao])


    useEffect(() => {
        if (open) {
            (async () => {
                await getFormalizacao();
            })()
        }
    }, [open])

    return <>
        <div>
            <Dialog open={open} className="FinanciamentoDocumentos" style={{ height: "100%", width: "100%" }} fullWidth={true} maxWidth="lg">
                <DialogTitle id="customized-dialog-title">
                    <div className="row DialogTitle">
                        <Typography variant="h6">Formalização</Typography>
                        {/* {onClose ? (
                            <IconButton aria-label="close" onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        ) : null} */}
                    </div>
                    <div className="row">
                        {/* Header das etapas */}
                        <div className="X12 etapas-formalizacao">
                            <div className="row">
                                {etapas.map((_etapa: string, index: number) => {
                                    return <div className={`X12 S${etapas.length}`}>
                                        <div className="etapa-formalizacao">
                                            <Chip label={Number(index + 1)}  color={etapasConcluidas.includes(_etapa) ? "primary" : "default"}/><div className={`title${etapasConcluidas.includes(_etapa) ? " active" : ""}`}>{(ETAPAS as any)[_etapa]}</div>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                        {/* Conentent das etapas */}
                    </div>
                </DialogTitle>
                <DialogContent>

                    {etapaAtual === ETAPA_FINANCIAMENTO_PLANOS && (
                        <div className="row planos">
                            <div className="X12">
                                <PlanosDataTable
                                    planos={planosState || []}
                                    onChange={(plano: FinanciamentosPlanosTypes) => {
                                        if (plano) {
                                            setPlanoState(plano);
                                        }
                                    }} />
                            </div>
                        </div>
                    )}
                    
                    {(etapaAtual === ETAPA_FINANCIAMENTO_ASSINATURA && assinatura)&& (<>
                        <div className="row assinatura">
                            <div className="X12 S6 S--offset3">
                                <Alert severity="info" variant="outlined" icon={<></>}>
                                    <div className="row X--middle">
                                        <div className="X12 S6 M4 L3">
                                            {assinatura.situacao === "gerada" && (<QRCodeSVG value={assinatura.url} width={"100%"} height={"100%"} />)}
                                            {assinatura.situacao === "analise" && (<>Em análise</>)}
                                        </div>
                                        <div className="X12 S6 M8 L9">
                                            Utilize a câmera do seu celular para scanear o QRcode e completar a etapa de assinatura.
                                            <br />
                                            Após completar a assinatura clique em <strong>VERIFICAR ASSINATURA</strong> para verificar a situação da assinatura e prosseguir.
                                            <br />
                                            {assinatura.situacao === "gerada" && <p>Caso link tenha expirado <a href="javascript:" onClick={async () => { await regerarAssinatura(); }}>clique aqui</a> para gerar novo link</p>}
                                        </div>
                                    </div>
                                </Alert>
                            </div>
                        </div>
                    </>)}

                    {etapaAtual === ETAPA_FINANCIAMENTO_DOCUMENTOS && documentosState?.length === 0 && (
                        <Alert severity="warning">
                            Não existe documentos para finalizar a etpa de formalização.
                            <br /> Clique abaixo para confirmar a etapa. 
                        </Alert>
                    )}

                    {(etapaAtual === ETAPA_FINANCIAMENTO_DOCUMENTOS && documentosState && documentosState?.length > 0) && (
                        <TabControl currentTabName={tabManutencao} onChangeTab={handleChangeTabManutencao}>
                            {documentosState && documentosState?.filter((doc) => doc.origem === TIPO_PESSOA_DOCUMENTO.PROPONENTE).length > 0 ? (
                                <TabContent name={"dados_pessoais"} label={"Titular"} visible={true}>
                                    <Documentos
                                        pedido={pedido}
                                        pessoas={pessoasState?.find(rec => rec.origem === TIPO_PESSOA_DOCUMENTO.PROPONENTE)}
                                        documentos={documentosState?.filter(rec => rec.origem === TIPO_PESSOA_DOCUMENTO.PROPONENTE) || []}
                                        onChange={async (value: any) => {
                                            if (value.documentos && value.documentos.length > 0) {
                                                const documentos = await saveArquivos(value.documentos);
                                                if (documentos) {
                                                    const upload: FinanciamentosUploadsType = {
                                                        url: documentos[0].url,
                                                        situacao: SITUACAO_FINANCIAMENTOS_UPLOADS.PREENCHIDO,
                                                        data_upload: moment().format("YYYY-MM-DD HH:mm:ss"),
                                                    }

                                                    const result = await financiamentoProvider.putUploads(documentos[0].id || "", upload);
                                                    if (result.statusCode === STATUS_CODE.OK) {
                                                        const state = [...documentosState || []];

                                                        const idx = state?.findIndex((doc: DocumentosPagamentosType) => doc.id === documentos[0].id);
                                                        if (idx > -1) {
                                                            state[idx].situacao = SITUACAO_FINANCIAMENTOS_UPLOADS.PREENCHIDO;
                                                        }

                                                        setDocumentosState(state);
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </TabContent>
                            ) : <></>}
                            {documentosState && documentosState?.filter((doc) => doc.origem === TIPO_PESSOA_DOCUMENTO.CONJUGE).length > 0 ? (
                                <TabContent name={"dados_pessoais_conjuge"} label={"Cônjuge"} visible={true}>
                                    <Documentos
                                        pedido={pedido}
                                        pessoas={pessoasState?.find(rec => rec.origem === TIPO_PESSOA_DOCUMENTO.CONJUGE)}
                                        documentos={documentosState?.filter(rec => rec.origem === TIPO_PESSOA_DOCUMENTO.CONJUGE) || []}
                                        onChange={async (value: any) => {
                                            if (value.documentos && value.documentos.length > 0) {
                                                const documentos = await saveArquivos(value.documentos);
                                                if (documentos) {
                                                    const upload: FinanciamentosUploadsType = {
                                                        url: documentos[0].url,
                                                        situacao: SITUACAO_FINANCIAMENTOS_UPLOADS.PREENCHIDO,
                                                        data_upload: moment().format("YYYY-MM-DD HH:mm:ss"),
                                                    }

                                                    const result = await financiamentoProvider.putUploads(documentos[0].id || "", upload);
                                                    if (result.statusCode === STATUS_CODE.OK) {
                                                        const state = [...documentosState || []];

                                                        const idx = state?.findIndex((doc: DocumentosPagamentosType) => doc.id === documentos[0].id);
                                                        if (idx > -1) {
                                                            state[idx].situacao = SITUACAO_FINANCIAMENTOS_UPLOADS.PREENCHIDO;
                                                        }

                                                        setDocumentosState(state);
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </TabContent>) : <></>}
                            {pessoasState ? pessoasState?.map((row, index) => {
                                if (row.origem === TIPO_PESSOA_DOCUMENTO.AVALISTA) {
                                    const documentosAvalista = documentosState?.filter(rec => rec.origem === TIPO_PESSOA_DOCUMENTO.AVALISTA && rec.documento === row.documento);
                                    if (!documentosAvalista || !documentosAvalista.length) {
                                        return null;
                                    }

                                    return (
                                        <TabContent key={`aba-avalista-${index}`} name={"dados_pessoais_avalista_" + index} label={`Avalista ${row.documento}`} visible={true}>
                                            <Documentos
                                                pedido={pedido}
                                                pessoas={row}
                                                documentos={documentosAvalista}
                                                onChange={async (value: any) => {
                                                    if (value.documentos && value.documentos.length > 0) {
                                                        const documentos = await saveArquivos(value.documentos);
                                                        if (documentos) {
                                                            const upload: FinanciamentosUploadsType = {
                                                                url: documentos[0].url,
                                                                situacao: SITUACAO_FINANCIAMENTOS_UPLOADS.PREENCHIDO,
                                                                data_upload: moment().format("YYYY-MM-DD HH:mm:ss"),
                                                            }

                                                            const result = await financiamentoProvider.putUploads(documentos[0].id || "", upload);
                                                            if (result.statusCode === STATUS_CODE.OK) {
                                                                const state = [...documentosState || []];

                                                                const idx = state?.findIndex((doc: DocumentosPagamentosType) => doc.id === documentos[0].id);
                                                                if (idx > -1) {
                                                                    state[idx].situacao = SITUACAO_FINANCIAMENTOS_UPLOADS.PREENCHIDO;
                                                                }

                                                                setDocumentosState(state);
                                                            }
                                                        }
                                                    }
                                                }}
                                            />
                                        </TabContent>
                                    )
                                }
                            }).filter((d) => !!d) || [] : []}
                        </TabControl>
                    )}
                </DialogContent>

                <div className="row actions">
                    <div className="X12 M6 X--order3 M--order1">
                        <FullWidthButton
                            onClick={() => {
                                onClose();
                            }}
                            text="Fechar"
                        />
                    </div>

                    {etapaAtual === ETAPA_FINANCIAMENTO_PLANOS && (<>
                        <div className="X12 M6 X--order1 M--order3">
                        <FullWidthButton
                            color="primary"
                            variant="contained"
                            disableElevation
                            onClick={async () => {
                                if (pedido?.codigo_venda) {
                                    const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido?.codigo_venda || "")
                                    if (substituicaoResult.statusCode !== STATUS_CODE.OK) return;
                                }

                                if (!validarPlanoSelecionado()) {
                                    return
                                }

                                let planoSelecionadoDescricao = "";

                                if (planoState?.valor_entrada) {
                                    planoSelecionadoDescricao += `Entrada de ${Formater.toString(planoState?.valor_entrada, TypeRecords.CURRENCY)} + `;
                                }

                                planoSelecionadoDescricao += `${planoState?.parcelas} X ${Formater.toString(planoState?.valor_parcela, TypeRecords.CURRENCY)} `

                                if (planoState?.carencia) {
                                    planoSelecionadoDescricao += `com carência de ${planoState?.carencia} dias para o pagamento.`;
                                }

                                confirmationDialog.setup({
                                    title: "Aviso!!!",
                                    content: <>
                                        Confirma os dados do plano de pagamento selecionado?<br />
                                        <strong>Plano Selecionado:</strong><br />
                                        {planoSelecionadoDescricao}
                                    </>,
                                    onConfirmation: async () => {
                                        confirmationDialog.close();
                                        await enviarPlano();
                                        
                                    },
                                    onClose: () => {
                                        confirmationDialog.close()
                                    }
                                })
                                confirmationDialog.open()
                            }}
                            text="Confirmar Plano"
                        />
                    </div>
                    </>)}
                    {etapaAtual === ETAPA_FINANCIAMENTO_ASSINATURA && (<>
                        <div className="X12 M6 X--order1 M--order3">
                        <FullWidthButton
                            color="primary"
                            variant="contained"
                            text="Verificar assinatura"
                            disableElevation
                            onClick={() => {
                                getFormalizacao();
                            }}
                        />
                    </div>
                    </>)}
                    {etapaAtual === ETAPA_FINANCIAMENTO_DOCUMENTOS && (<>
                        <div className="X12 M6 X--order1 M--order3">
                            <FullWidthButton
                                color="primary"
                                variant="contained"
                                disableElevation
                                onClick={async () => {
                                    if (pedido?.codigo_venda) {
                                        const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido?.codigo_venda || "")
                                        if (substituicaoResult.statusCode !== STATUS_CODE.OK) return;
                                    }

                                    if (!validarDocumentos()) {
                                        return
                                    }

                                    confirmationDialog.setup({
                                        title: "Aviso!!!",
                                        content: `Confirmar ${documentosState?.length === 0 ? "etapa de documentos" : "envio dos documentos"}?`,
                                        onConfirmation: async () => {
                                            confirmationDialog.close();

                                            if (pedido?.codigo_venda) {
                                                const pedidosProvider = new PedidosProvider();
                                                const responsePedido: IDataResponse<PedidoType[]> = await pedidosProvider.getPedidos(pedido.codigo_venda);
                                                if (responsePedido.statusCode !== STATUS_CODE.OK) return;
                                            }

                                            saveEnviarDocumentos();

                                            if (onConfirm) {
                                                onConfirm(false);
                                            }
                                        },
                                        onClose: () => {
                                            confirmationDialog.close()
                                        }
                                    })
                                    confirmationDialog.open()
                                }}
                                text={`${documentosState?.length === 0 ? "Confirmar etapa" : "Enviar Documentos"}`}
                            />
                        </div>
                    </>)}
                </div>
            </Dialog>
        </div>
    </>
}

export { FinanciamentoDocumentos };